import React from "react";
import ReactMarkdown from "react-markdown";
import perfIcon from "../../../assets/icons/perf-icon.png";
import styles from "./GscReportViewer.module.css";
import uiStyles from "../../reportViewers/ReportUIPrimitives.module.css";
import { renderParagraphs } from "./utils.jsx";

const parseSummaryLines = (markdown = "") => {
  const match = String(markdown || "").match(/Summary:\s*([\s\S]*)$/i);
  if (!match) return [];
  return String(match[1] || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => line.replace(/^[-\u2022]\s*/, ""))
    .filter((line) => !/^\*\*.*assessment.*\*\*$/i.test(line));
};

const GscReportAssessmentViewerV2 = ({ markdown }) => {
  if (!markdown) return null;
  const summaryLines = parseSummaryLines(markdown);

  return (
    <div className={styles.card}>
      <div className={styles.hero}>
        <div className={styles.heroLeft}>
          <div className={styles.heroIcon} aria-hidden="true">
            <img src={perfIcon} alt="Performance" width={18} height={18} />
          </div>
          <h4 className={styles.heroTitle}>Performance</h4>
        </div>
        <p className={styles.heroSubtitle}>
          Shopify search signals and user behaviour pulse
        </p>
      </div>

      {summaryLines.length > 0 ? (
        <div className={styles.sectionCard}>
          <div className={styles.sectionHeader}>Analysis</div>
          <div className={styles.summaryBody}>
            {summaryLines.map((line, idx) => (
              <div key={`sum-${idx}`} className={styles.summaryRow}>
                <span className={uiStyles.summaryCheck} aria-hidden="true" />
                <ReactMarkdown
                  components={{
                    p: ({ children }) => <span>{children}</span>,
                    strong: ({ children }) => (
                      <strong style={{ fontWeight: 700 }}>{children}</strong>
                    ),
                  }}
                >
                  {line}
                </ReactMarkdown>
              </div>
            ))}
          </div>
        </div>
      ) : (
        renderParagraphs(markdown, styles)
      )}
    </div>
  );
};

export default GscReportAssessmentViewerV2;
